function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from "react";
import { func, shape } from "prop-types";
import _isEqual from "lodash/isEqual";
import { OptionCheckbox } from "#library/components/SelectFilter/customComponents/Option/OptionCheckbox";
import { selectTypes } from "#library/components/SelectFilter/Select/types/types";
export var GroupHeadingCheckbox = function GroupHeadingCheckbox(props) {
  var getValue = props.getValue,
    setValue = props.setValue,
    optionsOfTheGroup = props.data.options;

  // get all options already selected
  var currentOptions = getValue();
  var optionIsIncludedInOptionsList = function optionIsIncludedInOptionsList(consideredOption, optionsList) {
    return optionsList.some(function (option) {
      return _isEqual(consideredOption, option);
    });
  };

  // Boolean to know if all options inside the group are selected
  // if true, this mean that the group header should also be displayed as selected
  var areAllGroupedOptionsSelected = optionsOfTheGroup.every(function (option) {
    return optionIsIncludedInOptionsList(option, currentOptions);
  });

  // Boolean to know if at least one option inside the group is selected
  // if true, this mean that the group header should also be displayed as indeterminate
  var isOneGroupedOptionsSelected = optionsOfTheGroup.some(function (option) {
    return optionIsIncludedInOptionsList(option, currentOptions);
  });

  // remove all options inside the group from options already selected
  var currentOptionsWithoutGrouped = currentOptions.filter(function (option) {
    return !optionIsIncludedInOptionsList(option, optionsOfTheGroup);
  });

  // add all options inside the group to options already selected.
  var currentOptionsWithGrouped = [].concat(_toConsumableArray(currentOptionsWithoutGrouped), _toConsumableArray(optionsOfTheGroup));
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (areAllGroupedOptionsSelected) {
        setValue(currentOptionsWithoutGrouped, "select-option");
      } else {
        setValue(currentOptionsWithGrouped, "select-option");
      }
    }
  }, /*#__PURE__*/React.createElement(OptionCheckbox, _extends({}, props, {
    isIndeterminate: isOneGroupedOptionsSelected,
    isSelected: areAllGroupedOptionsSelected,
    isFocused: false,
    isHeadingOption: true
  })));
};
GroupHeadingCheckbox.propTypes = {
  getValue: func.isRequired,
  setValue: func.isRequired,
  data: shape({
    options: selectTypes.options
  }).isRequired
};